var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "16px",
    viewBox: "0 0 22 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B6C7AB54-D433-42B1-8602-615E80D52E99") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-204.000000, -4879.000000)",
    fill: "#464646"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.12,4893.08 C225.606011,4893.08 226,4893.47399 226,4893.96 C226,4894.44601 225.606011,4894.84 225.12,4894.84 L204.88,4894.84 C204.393989,4894.84 204,4894.44601 204,4893.96 C204,4893.47399 204.393989,4893.08 204.88,4893.08 L225.12,4893.08 Z M224,4883.25 C224.966498,4883.25 225.75,4884.0335 225.75,4885 L225.75,4885 L225.75,4889 C225.75,4889.9665 224.966498,4890.75 224,4890.75 L224,4890.75 L206,4890.75 C205.033502,4890.75 204.25,4889.9665 204.25,4889 L204.25,4889 L204.25,4885 C204.25,4884.0335 205.033502,4883.25 206,4883.25 L206,4883.25 Z M224,4884.75 L206,4884.75 C205.861929,4884.75 205.75,4884.86193 205.75,4885 L205.75,4885 L205.75,4889 C205.75,4889.13807 205.861929,4889.25 206,4889.25 L206,4889.25 L224,4889.25 C224.138071,4889.25 224.25,4889.13807 224.25,4889 L224.25,4889 L224.25,4885 C224.25,4884.86193 224.138071,4884.75 224,4884.75 L224,4884.75 Z M225.12,4879 C225.606011,4879 226,4879.39399 226,4879.88 C226,4880.36601 225.606011,4880.76 225.12,4880.76 L204.88,4880.76 C204.393989,4880.76 204,4880.36601 204,4879.88 C204,4879.39399 204.393989,4879 204.88,4879 L225.12,4879 Z",
    id: "Day"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDay);
export default __webpack_public_path__ + "static/media/CalendarDay.91ac09ec293e536893d33cd785c1dca9.svg";
export { ForwardRef as ReactComponent };